<app-page [menuItems]="menuItems" [parentRoute]="parentRoute"></app-page>
